<template>
  <div :class="['loader-inline-block', ...$attrs.class]" :style="$attrs.style">
    <img src="/assets/loading.gif" />
  </div>
</template>

<script>
export default {
name: "loader-inline"
}
</script>

<style lang="css">
.loader-inline-block {
  text-align: center;
}
.loader-inline-block img
{
  width: 100px;
  height: 100px;
}
</style>
